// Edit account parameters.
import React from 'react';
import {FormattedMessage} from "react-intl";
import {AiOutlineCloseCircle} from "react-icons/ai";

export default class StreamLoginView extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        errorCleared: false,
        stream_user: ''
      };

      this.handleStreamUserChange = this.handleStreamUserChange.bind(this);
      this.handleSubmitStreamUser = this.handleSubmitStreamUser.bind(this);
      this.onCloseModal = this.onCloseModal.bind(this);
    }

    handleStreamUserChange(e) {
        this.setState({stream_user: e.target.value});
    }

    handleSubmitStreamUser(e) {
        e.preventDefault();
        this.setState({errorCleared: false});
        console.log('create login');
        this.props.onCreateStreamUser(
            this.props.topic,
            this.state.stream_user.trim()
        );
        this.props.onHideStreamLogin();
    }

    onCloseModal(e) {
        e.preventDefault();
        e.stopPropagation();
        this.props.onHideStreamLogin();
    }

    render() {
      let submitClasses = 'primary';
      if (this.props.disabled) {
        submitClasses += ' disabled';
      }
      return (
        <div className="stream-login-modal">
          <div className="stream-login-modal-wrapper">
            <div className="stream-login-modal-title">
              <h3>Join the chat</h3>
              <div className="close_modal_button">
                <a className="close_modal_link" onClick={this.onCloseModal}>
                  <AiOutlineCloseCircle />
                </a>
              </div>
            </div>
            <div className="stream-login-modal-content">
              <form className="panel-form-column" onSubmit={this.handleSubmitStreamUser}>
                <div className="panel-form-row">
                  <FormattedMessage id="stream_user" defaultMessage="Display Name"
                    description="Input placeholder for email entry">{
                      (stream_user_prompt) => <input type="text" className='' placeholder={stream_user_prompt} autoComplete="stream_user"
                      value={this.state.stream_user} onChange={this.handleStreamUserChange} required/>
                  }</FormattedMessage>
                </div>
                <div className="dialog-buttons">
                  <button className={submitClasses} type="submit">
                    <FormattedMessage id="button_sign_in_stream" defaultMessage="Sign up"
                    description="Join stream chat [Sign Up]" />
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        );
    }
};
